import * as Actions from 'actions/types';

export const app = (state = {}, action) => {    

    switch(action.type) {  
        case Actions.UPDATE_APP:
        case Actions.FETCH_REQUEST:
        case Actions.SHOW_HIDE_LOADER:
            return Object.assign({}, state, action.app);  
        default:
            return state;
    }
};